import { PropsWithChildren } from 'react';

interface ShowProps extends PropsWithChildren {
  when: unknown;
}

export const Show = ({ when, children }: ShowProps) => {
  return when ? children : null;
};
